import React from 'react';
import {observer} from 'mobx-react';
import {PropTypes} from 'prop-types';
import {RatingAsText} from 'fn-common-ui';

@observer
export class AppDetailBanner extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    rating: PropTypes.number
  };

  render() {
    if (!this.props.data) return null;
    return (
      <section className="app-detail-banner">
        <div className="container">
          <div className="row">
            <div className="app-detail-banner-icon col-3">
              <img
                src={this.props.data.icon_path}
                width="100%"
                height="auto"
                alt={`App Icon for ${this.props.data.app_name}`}
              />
            </div>
            <div className="app-detail-banner-text col-9">
              <h1>{this.props.data.app_name}</h1>
              <div className="col-4">
                <dl className="app-detail-banner-definitions">
                  <div>
                    <dt>Platform:</dt>
                    <dd>{this.props.data.platform}</dd>
                  </div>
                </dl>
                <div className="app-detail-banner-ratings">
                  <span className="app-detail-banner-stars">
                    <RatingAsText
                      rating={this.props.data.avgStars}
                      reviewCount={this.props.data.reviews_count}
                    />
                  </span>
                </div>
              </div>
              <div className="col-4">
                <dl className="app-detail-banner-definitions">
                  <div>
                    <dt>
                      {this.props.data.numberOfViews != 1 ? 'views:' : 'view:'}
                    </dt>
                    <dd>{this.props.data.numberOfViews}</dd>
                  </div>
                  <div>
                    <dt>
                      {this.props.data.isInternalApp
                        ? `download${
                            this.props.data.download_count != 1 ? 's:' : ':'
                          }`
                        : `download intent${
                            this.props.data.download_count != 1 ? 's:' : ':'
                          }`}
                    </dt>
                    <dd>{this.props.data.download_count}</dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
